export default __webpack_public_path__ + "static/media/college1.928975d3.jpg";